<template>
  <div v-editable="blok">
    <div v-if="index === 0">
      <NewPodcast
        v-bind:headline="blok.Headline"
        v-bind:speaker="blok.Speaker"
        v-bind:image="blok.Image"
        v-bind:podcastupload="blok.Podcastupload"
        v-bind:podcasttext="blok.Podcasttext"
        v-bind:date="blok.Date"
        v-bind:uid="blok._uid"
        v-bind:apple="blok.applelink.url"
        v-bind:google="blok.googlelink.url"
        v-bind:spotify="blok.spotifylink.url"
        v-bind:rss="blok.rsslink.url"
      ></NewPodcast>
    </div>

    <div v-if="index > 0">
      <div>
        <OldPodcast
          v-bind:headline="blok.Headline"
          v-bind:speaker="blok.Speaker"
          v-bind:image="blok.Image"
          v-bind:podcastupload="blok.Podcastupload"
          v-bind:podcasttext="blok.Podcasttext"
          v-bind:date="blok.Date"
          v-bind:uid="blok._uid"
          v-bind:apple="blok.applelink.url"
          v-bind:google="blok.googlelink.url"
          v-bind:spotify="blok.spotifylink.url"
          v-bind:rss="blok.rsslink.url"
        ></OldPodcast>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["blok", "index"],
  components: {
    NewPodcast: () =>
      import("@/components/Podcasts/NewPodcast/AppNewPodcast.vue"),
    OldPodcast: () =>
      import("@/components/Podcasts/OldPodcast/AppOldPodcast.vue")
  }
};
</script>

